import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { setUnauthorizedHandler } from '../api/client';
import { config } from '../config';

// UnauthorizedBridge wires apiFetch's 401 callback to OIDC sign-out. When the
// server reports the local session is unusable (token revoked, user row gone,
// JWT past silent-renew, Zitadel rejected the token at /userinfo even though
// the local JWT verify passed), tear down OIDC state and bounce to Zitadel.
//
// SessionCookieBridge picks up the user→null transition that removeUser()
// triggers and DELETEs the apex sa_session + sa_csrf cookies, so we don't
// have to do that cleanup here.
//
// Mounted by both main.tsx (admin SPA) and portal/main.tsx (signup portal) —
// any apiFetch caller in the bundle benefits from the single dispatch.
// E2E mode skips the redirect (CI uses a static token that intentionally
// never expires; a 401 there is a test failure, not a real auth state).
export function UnauthorizedBridge() {
  const auth = useAuth();
  useEffect(() => {
    if (config.e2eDevToken !== null) return;
    setUnauthorizedHandler(() => {
      void auth.removeUser().finally(() => {
        void auth.signinRedirect();
      });
    });
    return () => setUnauthorizedHandler(null);
  }, [auth]);
  return null;
}
